import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { productionOrderStates as state } from '../../Config/productionOrderStates'
import Timer from '../Shared/Timer';


export default function OrderState(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    let stateIcon = <React.Fragment></React.Fragment>;
    switch (props.productionOrder.productionOrderStatus) {
        case state.RUNNING:
            stateIcon = <PlayArrowRoundedIcon className={classes.play}></PlayArrowRoundedIcon>;
            break;
        case state.PAUSED:
            stateIcon = <PauseRoundedIcon className={classes.pause} ></PauseRoundedIcon>;
            break;
        case state.STOPPED:
            stateIcon = <div className={classes.stop}></div>;
            break;
        case state.DONE:
            stateIcon = <img className={classes.done} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img>
            break;
        case state.PLANNED:
            stateIcon = <img className={classes.planned} alt="planned" src={process.env.PUBLIC_URL + '/img/planned.svg'}></img>
            break;
        default:
    }

    let showElapsed = props.productionOrder.productionOrderStatus === state.PAUSED || props.productionOrder.productionOrderStatus === state.RUNNING

    return <div className={classes.orderState}>
        <div className={classes.stateContainer}>
            <div className={classes.icon}>{stateIcon}</div>
            <div className={classes.stateElapsed}>
                <div className={classes.state} style={{ paddingTop: showElapsed ? "0px" : "3px" }}>{t(props.productionOrder.productionOrderStatus)}</div>
                {showElapsed ?
                    <div className={classes.elapsed}><Timer startTime={props.productionOrder.startedOn} {...props}></Timer></div>
                    : <React.Fragment></React.Fragment>
                }
            </div>
        </div>
        <NavLink className={classes.navButton} to={`/order/${props.productionOrder.id}`}>
        <button className={classes.editButton}>
                    <div className={classes.buttonContent}>
                        <div className={classes.svg}><svg xmlns="http://www.w3.org/2000/svg" width="17.769" height="17.821" viewBox="0 0 17.769 17.821"><defs></defs><path className="a" fill="#FFFFFF" fillRule="evenodd" d="M17.208,5.978,6.49,16.9a2.042,2.042,0,0,1-1.267.6l-3.381.316A1.662,1.662,0,0,1,0,16.1L.178,12.79a1.947,1.947,0,0,1,.558-1.261L11.455.608A2.055,2.055,0,0,1,14.309.546l2.838,2.649A1.934,1.934,0,0,1,17.208,5.978Zm-15.5,6.459a.649.649,0,0,0-.186.42l-.175,3.308a.332.332,0,0,0,.368.343L5.1,16.191a.681.681,0,0,0,.422-.2l7.629-7.773L9.373,4.626Zm8.6-8.759L14.078,7.27l2.158-2.2a.645.645,0,0,0-.02-.928L13.378,1.494a.685.685,0,0,0-.951.021Z" /></svg></div>
                        <div className={classes.editWord}>{t('Edit')}</div>
                    </div>
                </button>
        </NavLink>
    </div>
}

const useStyles = makeStyles({
    orderState: {
        marginTop: "20px",
        marginLeft: "10px",
        height: "155px",
        float: "left",
        width: "145px"
    },

    buttonContent: {
        width: "fit-content",
        overflowX:"auto",
        marginLeft:"auto",
        marginRight:"auto"
    },
    editButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        display: "block",
        padding: "12px",
        cursor: "pointer",
        marginTop: "10px",
        height: "60px",
        marginLeft: "10px",
        border: "none",
        outline: "none",
        width: "100%",
        borderRadius: "5px",
        "&:hover": {
            background: FlagstoneTheme.palette.primary.main
        },
    },
    editWord: {
        float: "left",
        color: "#FFFFFF",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium'
    },
    svg: {
        float: "left",
        marginRight: "5px",
        marginTop: "2px"
    },
    play: {
        color: "#5CC958",
        height: "40px",
        width: "40px"
    },
    stop: {
        height: "20px",
        width: "20px",
        backgroundColor: "#D84949",
        borderRadius: "3px",
        margin: "10px",
        marginTop: "8px"
    },
    pause: {
        height: "35px",
        width: "35px",
        color: "#F59127",
        marginLeft: "5px"
    },
    cancel: {
        margin: "10px",
        marginTop: "8px",
        marginLeft: "12px"
    },
    planned: {
        paddingTop: "5px",
        marginRight: "10px",
        marginLeft: "5px"
    },
    done: {
        marginRight: "10px",
        paddingTop: "10px",
        marginLeft: "5px"

    },
    icon: {
        float: "left"
    },
    state: {
        textTransform: "uppercase",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        display: "block"
    },
    stateElapsed: {
        float: "left",
        marginLeft: "5px",
        marginTop: "5px"
    },
    elapsed: {
        fontSize: "10px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block"
    },
    stateContainer: {
        display: "block",
        height: "50px"
    }

});